module.exports = __webpack_public_path__ + "static/media/emptycart.819a47b8.jpg";